var chunkMapping = {
	"0": [
		4938
	],
	"76": [
		5056
	],
	"151": [
		5131
	],
	"152": [
		5132
	],
	"155": [
		5135
	],
	"156": [
		5136
	],
	"157": [
		5137
	],
	"158": [
		5138
	],
	"159": [
		5139
	],
	"160": [
		5140
	],
	"161": [
		5141
	],
	"162": [
		5142
	],
	"163": [
		5143
	],
	"164": [
		5144
	],
	"165": [
		5145
	],
	"166": [
		5146
	],
	"167": [
		5147
	],
	"168": [
		5148
	],
	"169": [
		5149
	],
	"170": [
		5150
	],
	"171": [
		5151
	]
};
var idToExternalAndNameMapping = {
	"4938": [
		"default",
		"./Containers",
		3807
	],
	"5056": [
		"default",
		"./OrderlessInvoices",
		3807
	],
	"5131": [
		"default",
		"./AsyncEventTracker",
		3807
	],
	"5132": [
		"default",
		"./HostWrapper",
		3807
	],
	"5135": [
		"default",
		"./CheckoutV3",
		3807
	],
	"5136": [
		"default",
		"./CheckoutConfirmation",
		3807
	],
	"5137": [
		"default",
		"./ContactCreditCards",
		3807
	],
	"5138": [
		"default",
		"./AuditDialog",
		3807
	],
	"5139": [
		"default",
		"./InvoiceBlocksOrderDialog",
		3807
	],
	"5140": [
		"default",
		"./InvoiceDialog",
		3807
	],
	"5141": [
		"default",
		"./PaymentDueModal",
		3807
	],
	"5142": [
		"default",
		"./PaymentModal",
		3807
	],
	"5143": [
		"default",
		"./PaymentHistory",
		3807
	],
	"5144": [
		"default",
		"./PaymentConfigurations",
		3807
	],
	"5145": [
		"default",
		"./PaymentPreferences",
		3807
	],
	"5146": [
		"default",
		"./ManagePaymentProcessing",
		3807
	],
	"5147": [
		"default",
		"./MobilePaymentsWrapper",
		3807
	],
	"5148": [
		"default",
		"./Challenge",
		3807
	],
	"5149": [
		"default",
		"./ManagePaymentMethods",
		3807
	],
	"5150": [
		"default",
		"./LightspeedReports",
		3807
	],
	"5151": [
		"default",
		"./ShippingPromotionsListContainer",
		3807
	]
};
var idToRemoteMap = {
	"4938": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3807
		}
	],
	"5056": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3807
		}
	],
	"5131": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3807
		}
	],
	"5132": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3807
		}
	],
	"5135": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3807
		}
	],
	"5136": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3807
		}
	],
	"5137": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3807
		}
	],
	"5138": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3807
		}
	],
	"5139": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3807
		}
	],
	"5140": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3807
		}
	],
	"5141": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3807
		}
	],
	"5142": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3807
		}
	],
	"5143": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3807
		}
	],
	"5144": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3807
		}
	],
	"5145": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3807
		}
	],
	"5146": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3807
		}
	],
	"5147": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3807
		}
	],
	"5148": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3807
		}
	],
	"5149": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3807
		}
	],
	"5150": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3807
		}
	],
	"5151": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3807
		}
	]
};
__webpack_require__.federation.bundlerRuntimeOptions.remotes = {idToRemoteMap,chunkMapping, idToExternalAndNameMapping, webpackRequire:__webpack_require__};
__webpack_require__.f.remotes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.remotes({idToRemoteMap,chunkMapping, idToExternalAndNameMapping, chunkId, promises, webpackRequire:__webpack_require__});
}